/** `#RRGGBB` → `"r, g, b"`. CSS `rgba(…)` 의 괄호 안에 그대로 넣는 용도다. */
export const hexToRgbString = (hexColor: string) =>
  `${parseInt(hexColor.slice(1, 3), 16)}, ${parseInt(
    hexColor.slice(3, 5),
    16,
  )}, ${parseInt(hexColor.slice(5, 7), 16)}`;
